require("es6-promise").polyfill();
const Vuex = require("vuex");

import Vue from "vue";
//import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  /** @type {{user: {cnxUserId:Number, name: String, email:String, roleLevel: Number, accessLevel: string, isVerified: boolean},
   * authCheck: Promise<boolean>,
   * loggedIn:(undefined|boolean),
   * mapData: MapData,
   * subscriptions: Subscription[],
   * subscriptionDefault: Subscription,
   * }} */
  state: {
    user: {
      cnxUserId: null,
      name: null,
      email: null,
      //phoneNumber: null,
      roleLevel: null,
      isVerified: false,
    },
    authCheck: null,
    loggedIn: undefined,
    mapData: null,
    subscriptions: [],
    contactMethods: null,
    contactAddresses: null,
    passengerId: 0,
    subscriptionDefault: {
      subscriptionId: undefined,
      passengerId: undefined,
      enabled: false,
      platformTag: 0,
      projectTag: 0,
      routeNo: "",
      routeName: "",
      destination: "",
      notBefore: null,
      notAfter: null,
      warningTime: null,
      tripScheduleTag: null,
      weekdayNames: [],
      routePositionBegin: null,
      routePositionEnd: null,
      validFrom: null,
      validTo: null,
    },
    notification: null,
    initData: null,
    domain: null,
    isDev: process.env.NODE_ENV === "development",
    axios: axios.create({
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
      baseURL:
        process.env.NODE_ENV === "development"
          ? "https://localhost/subscription/"
          : undefined,
      validateStatus: (status) => status >= 200 && status < 400,
    }),
  },
  mutations: {
    setUser(state, payload) {
      payload = payload || {};
      state.user.cnxUserId = payload.cnxUserId;
      state.user.name = payload.name;
      state.user.email = payload.email;
      state.user.isVerified = payload.isVerified;
      state.user.roleLevel = payload.roleLevel;
      state.user.accessLevel = payload.accessLevel;
      if (payload.cnxUserId) state.loggedIn = true;
    },
    logout(state) {
      state.user.cnxUserId = null;
      state.user.name = null;
      state.user.email = null;
      state.user.roleLevel = null;
      state.loggedIn = false;
      state.user.accessLevel = null;
    },
    setInitData(state, payload) {
      Vue.set(state, "initData", payload);
    },
    setMapData(state, payload) {
      Vue.set(state, "mapData", payload);
    },
    setContactMethods(state, payload) {
      Vue.set(state, "contactMethods", payload);
    },
    setPassengerId(state, payload) {
      Vue.set(state, "passengerId", payload);
    },

    setSubscriptions(state, payload) {
      Vue.set(
        state,
        "subscriptions",
        [...payload].map((x) => Object.assign({}, state.subscriptionDefault, x))
      );
    },
    addSubscription(state, payload) {
      state.subscriptions.push(
        Object.assign({}, state.subscriptionDefault, payload)
      );
    },
    editSubscription(state, payload) {
      var sub = state.subscriptions.find((x) =>
        x.localId
          ? x.localId == payload.localId
          : x.subscriptionId == payload.subscriptionId
      );
      if (sub)
        state.subscriptions.splice(
          state.subscriptions.indexOf(sub),
          1,
          Object.assign({}, sub, payload)
        );
    },
    removeSubscription(state, payload) {
      var i = state.subscriptions.findIndex(
        (x) => x.subscriptionId == payload.subscriptionId
      );
      if (i > -1) state.subscriptions.splice(i, 1);
    },

    setContactAddresses(state, payload) {
      Vue.set(
        state,
        "contactAddresses",
        [...payload].map((x) => Object.assign({}, x))
      );
    },
    addContactAddress(state, payload) {
      state.contactAddresses.push(Object.assign({}, payload));
    },
    editContactAddress(state, payload) {
      var sub = state.contactAddresses.find((x) =>
        x.localId
          ? x.localId == payload.localId
          : x.subscriptionId == payload.subscriptionId
      );
      if (sub)
        state.subscriptions.splice(
          state.subscriptions.indexOf(sub),
          1,
          Object.assign({}, sub, payload)
        );
    },

    setNotification(state, payload) {
      Vue.set(state, "notification", payload);
    },
    setDomain(state, payload) {
      if (!state.isDev) {
        return;
      }

      if (!payload) {
        payload = "localhost";
      }

      state.domain = payload;
      state.axios.defaults.baseURL = `https://${payload}/subscription/`;
    },
  },
  actions: {
    authenticateWithToken({ state, commit }, token) {
      state.axios.defaults.headers.Authorization = "Bearer " + token;
      return state.axios
        .post("api/auth/authcheck")
        .then((response) => {
          return commit("setUser", response.data);
        })
        .catch((e) => {
          return commit("logout");
        });
    },

    authenticate({ state, commit }) {
      return state.axios
        .post("api/auth/authcheck")
        .then((response) => {
          return commit("setUser", response.data);
        });
    },

    isLoggedIn({ state, dispatch, commit }) {
      if (typeof state.loggedIn === "boolean")
        return new Promise(function (resolve) {
          state.authCheck = null;
          resolve(state.loggedIn);
        });

      if (state.authCheck) return state.authCheck;

      state.authCheck = dispatch("authenticate")
        .then((res) => {
          state.authCheck = null;
          return (state.loggedIn = true);
        })
        .catch((e) => {
          commit("logout");
          state.authCheck = null;
          return (state.loggedIn = false);
        });
      return state.authCheck;
    },
    getInitData({ commit }) {
      return state.axios
        .get("api/subscriptions/InitData")
        .then((response) => commit("setInitData", response.data));
    },
    getMapData({ commit }) {
      return state.axios
        .get("api/transit/mapdata")
        .then((response) => commit("setMapData", response.data));
    },
    getContactMethods({ state, commit }) {
      return state.axios
        .get("api/address/" + state.user.cnxUserId + "/types")
        .then((response) => commit("setContactMethods", response.data));
    },
    /** @typedef {{Color:string, Description:string, Geometry:string, Tag:string}} Connector
     * @typedef {{Tag:number, No:string, Name:string, VehicleType:number, X:number, Y:number}} Platform
     * @typedef {{Tag:number, No:string, Name:string}} StationPlatform
     * @typedef {{Name: string, Platforms: StationPlatform[], Tag: number, X: number, Y: number}} Station
     * @typedef {{Color: string, Name:string, Radius: number, X: number, Y: number}} Region
     * @typedef {{Color: string, Name: string, No: string, Patterns: {Tag: number, Geometry: string}[], Platforms: number[], Stations:number[], VehicleType: number }} Route
     * @typedef {{Name: string, Region: Region, Routes: Route[], Tag:number}} Project
     * @typedef {{MinX:number, MinY:number, MaxX:number, MaxY:number, Connectors: Connector[], Platforms: Platform[], Projects: Project[], Stations: Station[]}} MapData
     * */
    getPassengerData({ state }, actions) {
      return state.axios
        .get("api/passenger/" + state.user.cnxUserId)
        .then((response) => {
          actions.forEach((x) => x(response.data));
        })
        .catch((e) => {
          if (e && e.response && e.response.status == "404") {
            return state
              .axios({
                method: "post",
                url: "api/passenger/" + state.user.cnxUserId,
                data: `"${state.user.email}"`,
              })
              .then(() =>
                state.axios
                  .get("api/passenger/" + state.user.cnxUserId)
                  .then((response) => {
                    actions.forEach((x) => x(response.data));
                  })
                  .catch((e) =>
                    Promise.reject({
                      message:
                        "Could not retrieve passenger data after creating passenger",
                      error: e,
                    })
                  )
              )
              .catch((e) =>
                Promise.reject(
                  e.error
                    ? e
                    : {
                        message:
                          "Requested nonexistant passenger - Tried to create one and failed",
                        error: e,
                      }
                )
              );
          } else {
            return Promise.reject({
              message: "Could not retrieve passenger data",
              error: e,
            });
          }
        });
    },
    getSubscriptions({ commit, dispatch }) {
      return dispatch("getPassengerData", [
        (data) => commit("setPassengerId", data.passengerId),
        (data) => commit("setSubscriptions", data.subscriptions),
        (data) => commit("setContactAddresses", data.contactAddresses),
      ]);
    },

    getOnlyContactAddresses({ commit, dispatch }) {
      return dispatch("getPassengerData", [
        (data) => commit("setContactAddresses", data.contactAddresses),
      ]);
    },
  },
});
